import React, { memo, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import ReactMarkdown from 'react-markdown';
import PageContext from '../../../../../contexts/PageContext';
import { formatDateRangeMMMYYYY, safetyCheck } from '../../../../../utils';
import fontSizeOptions from '../../../../../constants/fontSizeOptions';

const useStyles = makeStyles({
  root: {
    fontSize: (props) => props,
  },
});

const WorkItem = ({ item, language, fontSize }) => {
  const { t } = useTranslation();
  const classes = useStyles({
    fontSize: fontSizeOptions['text-base'] + fontSize,
  });

  return (
    <div>
      <div className="flex justify-between items-center">
        <div className="flex flex-col text-left mr-2">
          <h3
            className="font-semibold"
            style={{ fontSize: fontSizeOptions['text-h3'] + fontSize }}
          >
            {item.website ? (
              <a href={item.website}>{item.company}</a>
            ) : (
              item.company
            )}
          </h3>
          <h3
            className="text-xs"
            style={{ fontSize: fontSizeOptions['text-h3'] + fontSize }}
          >
            {item.position}
          </h3>
        </div>
        {item.startDate && (
          <h3
            className=" mb-1"
            style={{ fontSize: fontSizeOptions['text-h3'] + fontSize }}
          >
            {formatDateRangeMMMYYYY(
              {
                startDate: item.startDate,
                endDate: item.endDate,
                language,
              },
              t,
            )}
          </h3>
        )}
      </div>
      {item.summary && (
        <ReactMarkdown
          className={`markdown mt-2 ${classes.root}`}
          source={item.summary}
        />
      )}
    </div>
  );
};

const WorkA = () => {
  const { data, heading: Heading } = useContext(PageContext);
  const { fontSize } = data.metadata.margins;

  return safetyCheck(data.work) ? (
    <div>
      <Heading fontSize={fontSize}>{data.work.heading}</Heading>
      <div className="grid gap-4">
        {data.work.items.map((x) => (
          <WorkItem
            key={x.id}
            item={x}
            language={data.metadata.language}
            fontSize={fontSize}
          />
        ))}
      </div>
    </div>
  ) : null;
};

export default memo(WorkA);
